import {
    IDocumentChangeHandler,
    IListener,
    IOfficeHost,
} from "./office-host.types";
import { environment } from '@env';
import * as cmmn from '@utils/index';
import Office from "@core/shared/office.instance";
import { isDevMode } from '@angular/core';
import {IQuickAction} from "@core/base/chat-setting-base";

export type TListenersMap = Map<
    Office.EventType,
    IListener[]
>;

export abstract class BaseHost implements IOfficeHost
{
    protected isReady = false;
    protected platform: Office.PlatformType = Office.PlatformType.PC;
    protected eventListeners: TListenersMap = new Map<Office.EventType, IListener[]>();
    private isDevMode: boolean = isDevMode();

    constructor()
    {
        Office.onReady((info) => {
            this.platform = info.platform;
            this.isReady = true;
        });
    }

    async waitReadyAsync(): Promise<void> {
        let max_count = 100; // wait 10 seconds
        while (!this.isReady && max_count-- > 0) {
            await cmmn.sleep(100);
        }

        if (max_count == 0) {
            throw new Error(`timeout has expired`);
        }
    }

    public async getDocumentIDAsync(): Promise<string> {
        if (this.isDevMode) {
            throw new Error("Method not implemented.");
        }

        return ''
    }

    public async setSelectedTextAsync(plainText: string): Promise<void> {
        if (this.isDevMode) {
            throw new Error("Method not implemented.");
        }
    }

    public async setSelectedImageAsync(fileName: string, b64Text: string): Promise<void> {
        if (this.isDevMode) {
            throw new Error("Method not implemented.");
        }
    }

    public checkDocumentReadable(): boolean { return false; }
    public async getDocumentTextAsync(): Promise<string> {
        if (this.isDevMode) {
            throw new Error("Method not implemented.");
        }

        return ''
    }
    public checkSelectable(): boolean { return false; }
    public checkEditable(): boolean { return false; }
    public getSelectedContentAsync(): Promise<string> { throw new Error('not implemented'); };
    public async onDocumentChange(handler: IDocumentChangeHandler): Promise<void> {
        if (this.isDevMode) {
            throw new Error('Method not implemented');
        }
    }
    public async attachImageToEmail(base64Image: string, filename: string): Promise<void> {
        if (this.isDevMode) {
            throw new Error('Method not implemented');
        }
    }

    public attachHandler(
        eventType: Office.EventType,
        eventHandler: IListener,
    ): void
    {
        if (!this.eventListeners.get(eventType)) {
            this.eventListeners.set(eventType, [ eventHandler ]);
        }
        else {
            const list = this.eventListeners.get(eventType) as IListener[];
            list.push(eventHandler);
        }
    }

    public detachHandler(eventType: Office.EventType, eventHandler: IListener): void
    {
        const listeners = this.eventListeners.get(eventType);
        if (!listeners) {
            return;
        }
        const index = listeners.indexOf(eventHandler, 0);
        if (index > -1) {
            listeners.splice(index, 1);
        }
    }

    public getQuickActions(): IQuickAction[] {
        return environment.quick_actions.default;
    }
}
